export default __webpack_public_path__ + "static/media/img/mv-logo-orig.webp";